import { useFilters } from "../useFilters";

/**
 * Hook spécifique pour gérer les filtres des workorders
 * @param resetPageCallback - Fonction pour réinitialiser la pagination
 * @returns - Interface pour manipuler les filtres
 */
export function usePlanningFilters(resetPageCallback: () => void) {
  // Fonction pour transformer les filtres avant sérialisation
  const transformForSerialization = (filters: Partial<EasyTech.PlanningFilterType>) => {
    const filtersCopy = { ...filters };
    
    if (filtersCopy.technician && !Array.isArray(filtersCopy.technician)) {
      filtersCopy.technician = [filtersCopy.technician];
    }
    if (filtersCopy.customer && !Array.isArray(filtersCopy.customer)) {
      filtersCopy.customer = [filtersCopy.customer];
    }
    if (filtersCopy.status && !Array.isArray(filtersCopy.status)) {
      filtersCopy.status = [filtersCopy.status];
    }
    return filtersCopy;
  };
  
  // Fonction pour transformer les filtres après désérialisation
  const transformForDeserialization = (decodedFilters: any): Partial<EasyTech.PlanningFilterType> => {
    const filters = { ...decodedFilters };
    if (filters.technician && Array.isArray(filters.technician)) {
      filters.technician = filters.technician.filter((id: any) => !!id);
    }
    if (filters.customer && Array.isArray(filters.customer)) {
      filters.customer = filters.customer.filter((id: any) => !!id);
    }
    return filters;
  };

  return useFilters<EasyTech.PlanningFilterType>(
    resetPageCallback, 
    {
      transformForSerialization,
      transformForDeserialization
    }
  );
} 